export function getPublicApiUrl (env: Partial<ImportMetaEnv>): string {
  return env.VUE_APP_PUBLIC_API_URL || '/public-api'
}
